import { useState, useEffect } from "react";
import axios from "axios";

/**
 * Hook genérico para GET/POST con cancelación.
 * @param {() => Promise<any>} fnPromise  función que devuelva la promesa axios
 * @param {Array} deps  dependencias que disparan la petición
 */
export default function useFetch(fnPromise, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setErr] = useState(null);

  useEffect(() => {
    if (!fnPromise) return;
    const controller = new AbortController();

    (async () => {
      try {
        setLoading(true);
        const res = await fnPromise(controller.signal);
        if (!controller.signal.aborted) setData(res.data);
      } catch (err) {
        if (!controller.signal.aborted) setErr(err);
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    })();

    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, loading, error };
}
